import { Component, OnInit } from '@angular/core';
import { SubscriptionService } from 'src/app/services/subscription/subscription.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-packagesitemap',
  templateUrl: './packagesitemap.component.html',
  styleUrls: ['./packagesitemap.component.css']
})
export class PackageSiteMapComponent implements OnInit {

  Submitted: boolean = false;
  PackageList: any;
  PackageSiteMapList: any;
  

  constructor(private subcriptionService: SubscriptionService, private LookupService: LookupService,
     public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }


  SiteMapModel = {
    IsActive: true,
    PackageID: 0,
    SiteMapTypeID:0,

  };


  validation() {
    return this.SiteMapModel.PackageID == 0;
  }

  SavePackageSiteMap(valid) {

    this.Submitted = true;
    if (valid && !this.validation()) {
      this.spinnerService.show();
      this.subcriptionService.SavePackageSiteMap(this.SiteMapModel.PackageID,JSON.stringify(this.PackageSiteMapList)).subscribe((data: any) => {
        this.GetAllPackageSiteMap();
        this.spinnerService.hide();
        this.Submitted = false;  
        this.globalHelper.CheckActionStatus(data);

      });
    }
  }

  GetAllPackageSiteMap() {
    this.Submitted = true;
    this.PackageSiteMapList=[];
    if (!this.validation()) {
    this.spinnerService.show();
    this.subcriptionService.GetAllPackageSiteMap(JSON.stringify(this.SiteMapModel)).subscribe((data: any) => {
      this.PackageSiteMapList = data.PackageSiteMapList;
      this.spinnerService.hide();
      this.Submitted = false;
    });
  }

  }
  

  ngOnInit() {

    this.GetAllPackage();
   this.BindSiteMapType();
  }

  SiteMapTypeList:any;
  BindSiteMapType() {
    this.LookupService.GetLookupsList('SiteMapType', '').subscribe((data: any) => {
      this.SiteMapTypeList = data.LookupItems;
      // this.UserTypeList.splice(0, 1)
    });
  };
  GetAllPackage() {

    this.LookupService.GetLookupsList('PackageAll', '').subscribe((data: any) => {
      this.PackageList = data.LookupItems;
    });
  }

 

}


